module.exports = __webpack_public_path__ + "static/media/cg.04e0c25a.jpg";